export default "__VITE_ASSET__Cd8rtWhI__"